import ProfessionalDevelopmentCard from '@/components/common/ProfessionalDevelopment/ProfessionalDevelopmentCard/ProfessionalDevelopmentCard';

export default ProfessionalDevelopmentCard;
